// src/pages/ImportantEvents.jsx
import React from 'react';

const ImportantEvents = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Important Events</h1>
      <p>Learn about key historical and religious events relevant to Ziyarat.</p>
    </div>
  );
};
export default ImportantEvents;